// Sentry — side-effect import. Initializes the React SDK at module load so
// any error thrown afterwards (including during initial render) is captured.
// MUST run before React renders (see main.tsx).
//
// DSN is read from VITE_SENTRY_DSN, inlined at build time by Vite. When it is
// empty/undefined (e.g. local dev, or a build without the CI secret) we never
// call Sentry.init at all — the SDK stays dormant and emits no network traffic.
//
// Tracing is intentionally OFF here (tracesSampleRate: 0, no browser-tracing
// integration): OpenTelemetry owns tracing for this portal, and enabling
// Sentry performance tracing would double-instrument page loads and requests.
// Sentry's job here is error reporting only. Replay is also disabled to keep
// quota low and avoid capturing user sessions.

import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  try {
    Sentry.init({
      dsn,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      ignoreErrors: ['ResizeObserver loop', 'ChunkLoadError', 'Network Error'],
    });
  } catch (err) {
    // Never let observability wiring crash the app.
    console.warn('[sentry] init failed; continuing without error tracking', err);
  }
}
